module.exports = "/fonts/Ki.eot?770f181b58cb3f1ec7a902b7842de863";